import type {
  JobTeaserCardProps,
  JobTeaserCardXinglet as JobTeaserCardXingletInterface,
} from '@xing-com/crate-jobs-xinglets';

import { JobTeaserCard } from './job-teaser-card';

export default class JobTeaserCardXinglet
  implements JobTeaserCardXingletInterface
{
  public getComponent(): React.ComponentType<JobTeaserCardProps> {
    return (props): React.ReactElement => <JobTeaserCard {...props} />;
  }
}
